var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogs(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "library_books_24px"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\xE2\x86\xB3 Light Color"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Mask",
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 4V16H8V4H20ZM18 6H10V8H18V6ZM10 9H18V11H10V9ZM14 12H10V14H14V12Z",
    fill: "white",
    fillOpacity: 0.54
  })), /*#__PURE__*/React.createElement("g", {
    id: "\xE2\x86\xB3 Dark Color"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Mask_2",
    d: "M4 22H18V20H4V6H2V20C2 21.1 2.9 22 4 22Z",
    fill: "white",
    fillOpacity: 0.54
  })), /*#__PURE__*/React.createElement("g", {
    id: "\xE2\x86\xB3 Dark Color_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Mask_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 16V4C6 2.9 6.9 2 8 2H20C21.1 2 22 2.9 22 4V16C22 17.1 21.1 18 20 18H8C6.9 18 6 17.1 6 16ZM8 16H20V4H8V16Z",
    fill: "white",
    fillOpacity: 0.54
  })), /*#__PURE__*/React.createElement("g", {
    id: "\xE2\x86\xB3 Dark Color_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Mask_4",
    d: "M10 9H18V11H10V9Z",
    fill: "white",
    fillOpacity: 0.54
  })), /*#__PURE__*/React.createElement("g", {
    id: "\xE2\x86\xB3 Dark Color_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Mask_5",
    d: "M10 12H14V14H10V12Z",
    fill: "white",
    fillOpacity: 0.54
  })), /*#__PURE__*/React.createElement("g", {
    id: "\xE2\x86\xB3 Dark Color_5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Mask_6",
    d: "M10 6H18V8H10V6Z",
    fill: "white",
    fillOpacity: 0.54
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogs);
export default __webpack_public_path__ + "static/media/logs.13ac21f13d929414b08a0809a9d56896.svg";
export { ForwardRef as ReactComponent };